export const ru = {
    'add-success': 'Продукт успешно добавлен',
    'change-success': 'Продукт успешно изменен',
    error: 'Произошла ошибка, повторите попытку',
    'remove-confirm': 'Вы действительно хотите удалить {product}?',
    'remove-success': 'Продукт успешно удален'
};
